import React, {useEffect} from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

const {recaptchaEnterpriseSiteKey} = window.Edu;

function initializeRecaptcha(callback = null) {
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaEnterpriseSiteKey}`;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);

  script.onload = () => {
    if (callback) {
      callback();
    }
  };

  script.onerror = () => {
    // eslint-disable-next-line no-console
    console.error('Failed to load reCAPTCHA Enterprise script');
  };
}

/**
 * Returns promise to get enterprise (v3) recaptcha token.
 *
 * @returns {Promise<*>}
 */
export async function getRecaptchaToken(action = '') {
  await new Promise(resolve => window.grecaptcha.enterprise.ready(resolve));

  const token = await window.grecaptcha.enterprise.execute(recaptchaEnterpriseSiteKey, {
    action,
  });

  return token;
}

export default function RecaptchaV3({action, setIsValid}) {
  async function recaptchaCallback() {
    const token = await getRecaptchaToken(action);

    const formData = new FormData();
    formData.append("recaptchaEnterpriseToken", token);
    formData.append("recaptchaEnterpriseAction", action);

    const result =
      await axios.post('/api/validateEnterpriseToken', formData, {headers: {'Content-Type': 'multipart/form-data'}});

    if (setIsValid) {
      setIsValid(result.data.valid);
    }
  }

  useEffect(() => {
    initializeRecaptcha(recaptchaCallback);
  }, [action]);

  return (
    <div className='v3' />
  )
}

RecaptchaV3.propTypes = {
  action: PropTypes.string,
  setIsValid: PropTypes.func
};

RecaptchaV3.defaultProps = {
  action: '',
  setIsValid: null
}
